<template>
  <div class="item-detail">
    <div class="title">
      {{ titleText }}
    </div>
    <div class="line" />
    <slot />
  </div>
</template>

<script>
import { Col, Row } from 'vant'

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col
  },
  props: {
    titleText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.item-detail {
  padding: .3rem;
  .title {
    font-size: 0.28rem;
    color: #aeaeae;
  }
  .line {
    border-bottom: 1px solid #000000;
    margin: 10px 0;
  }
}
</style>
